/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_TitleInputs */

const fr_admin_subscription_rights_title = /** @type {(inputs: Admin_Subscription_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formule`)
};

/**

* @param {Admin_Subscription_Rights_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_title = /** @type {((inputs?: Admin_Subscription_Rights_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_title(inputs)
});